<script setup lang="ts">
import { useFileImportStore } from "@/stores"
import useAnalytics from "@/utils/analytics"
import { captureError } from "@/utils/useEngineModel"
import { ref } from "vue"

const { trackEvent } = useAnalytics()

const importFile = ref()
const fileImportStore = useFileImportStore()
// Load file from input
async function handleFileInput() {
  const files = [...importFile.value.files]
  try {
    await fileImportStore.handleFileUpload(files)
  } catch (error) {
    captureError(error, { snackbar: true })
  }
}
// Trigger @change if the same file is uploaded twice.
function handleInputClick(event: Event) {
  const target = event.target as HTMLInputElement
  if (target) {
    target.value = ""
  }
}

function buttonClick() {
  trackEvent("file_import_clicked")
  importFile.value.click()
}
</script>

<template>
  <input
    ref="importFile"
    type="file"
    class="sr-only"
    accept=".tsv, .csv, .txt, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    data-test="upload-input"
    @click="handleInputClick"
    @change="handleFileInput"
  >
  <slot :button-click="buttonClick">
    <KButton
      variety="tertiary"
      color="violet"
      class="mt-2"
      @click="buttonClick()"
    >
      Browse
    </KButton>
  </slot>
</template>
